import { render, staticRenderFns } from "./pwdrecover.vue?vue&type=template&id=4d977870&scoped=true&"
import script from "./pwdrecover.vue?vue&type=script&lang=ts&"
export * from "./pwdrecover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d977870",
  null
  
)

export default component.exports